import { supabase } from '@/integrations/supabase/client';

export async function getOrCreateDefaultWorkspaceId(userId: string, userEmail: string): Promise<string> {
  console.log('[DEFAULT_WS] Getting/creating default workspace for:', userEmail);
  
  // Check if user is owner first
  const { data: isOwnerResult } = await supabase.rpc('is_owner');
  const isOwner = isOwnerResult || false;
  
  console.log('[DEFAULT_WS] Is owner:', isOwner);
  
  if (isOwner) {
    // Owners can access any workspace, try to find any workspace first
    const { data: workspaces, error } = await supabase
      .from('workspaces')
      .select('id, name, is_default')
      .order('is_default', { ascending: false })
      .limit(1);
    
    if (error) {
      console.error('[DEFAULT_WS] Error fetching workspaces:', error);
      throw error;
    }
    
    if (workspaces && workspaces.length > 0) {
      console.log('[DEFAULT_WS] Owner using existing workspace:', workspaces[0].id);
      return workspaces[0].id;
    }
    
    // No workspaces exist, owner needs to create one via edge function
    console.log('[DEFAULT_WS] No workspaces found, redirecting owner to workspace selection');
    throw new Error('NO_WORKSPACES_AVAILABLE');
  }
  
  // For regular users, find their workspaces through workspace_members
  const { data: memberWorkspaces, error: memberError } = await supabase
    .from('workspace_members')
    .select(`
      workspace_id,
      workspaces!inner(id, name, is_default)
    `)
    .eq('user_id', userId)
    .eq('status', 'active');
  
  if (memberError) {
    console.error('[DEFAULT_WS] Error fetching user workspaces:', memberError);
    throw memberError;
  }
  
  // Sort client-side to get default workspace first
  const sortedWorkspaces = (memberWorkspaces || []).sort((a, b) => {
    const aIsDefault = (a as any).workspaces?.is_default || false;
    const bIsDefault = (b as any).workspaces?.is_default || false;
    return Number(bIsDefault) - Number(aIsDefault);
  });
  
  if (sortedWorkspaces && sortedWorkspaces.length > 0) {
    const workspaceId = sortedWorkspaces[0].workspace_id;
    console.log('[DEFAULT_WS] Regular user using existing workspace:', workspaceId);
    return workspaceId;
  }
  
  // No workspaces for regular user - redirect to selection
  console.log('[DEFAULT_WS] No workspaces found for regular user');
  throw new Error('NO_WORKSPACES_AVAILABLE');
}